let config = {
  //url: "http://localhost:8000/"
  url: "https://api.b2b.qpix.io/"
  // url: 'http://139.162.249.124:5984'
};

export default config;
